module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-26.1e5fe972.png";